module.exports = __webpack_public_path__ + "static/media/speechActive.777ca4a2.svg";